module.exports = __webpack_public_path__ + "static/img/registerLogin.8673b79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fanclub/registerLogin.png
// module id = hZWg
// module chunks = 7